if (import.meta.env.MODE === "lmgo") {
  import("./entry-lmgo");
} else {
  import("./entry-charmdeer");
}
